import { render } from "./DisclosuresStep.vue?vue&type=template&id=3b49e745&scoped=true"
import script from "./DisclosuresStep.vue?vue&type=script&lang=js"
export * from "./DisclosuresStep.vue?vue&type=script&lang=js"

import "./DisclosuresStep.vue?vue&type=style&index=0&id=3b49e745&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b49e745"]])

export default __exports__